import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://paoletexuwmeuatvbkvf.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBhb2xldGV4dXdtZXVhdHZia3ZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3Mjk2MDEsImV4cCI6MjA3NjMwNTYwMX0.TYapGPhQD75eyoaAy_NRouX8aLZLjVFego2YJN4zy74";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
